export const mobileMenuLinks = (translation) => {
  return [
    {
      name: `${translation.sideMenu.Dashboard}`,
      url: '/dashboard',
    },
    {
      name: `${translation.sideMenu.Invoices_Incomes}`,
      url: '/invoices/incomes',
    },
    {
      name: `${translation.sideMenu.Invoices_Expences}`,
      url: '/invoices/expenses',
    },
    {
      name: `${translation.sideMenu.Invoices_Drafts}`,
      url: '/invoices/drafts',
    },
    {
      name: `${translation.sideMenu.Last_Transactions}`,
      url: '/invoices/create',
    },
    {
      name: `${translation.sideMenu.Reports}`,
      url: '/reports',
    },
    {
      name: `${translation.sideMenu.Instructions}`,
      url: '/instructions',
    },
  ];
};
